var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLegacyTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.2 3.201h-4v-1.336c-.04-1.066-.934-1.9-2-1.863h-2.4c-1.066-.036-1.96.797-2 1.863v1.336h-4c-.441 0-.8.359-.8.8 0 .442.359.8.8.8h.8v8.8c0 1.325 1.075 2.399 2.4 2.399h8c1.325 0 2.4-1.075 2.4-2.4v-8.8h.8c.441 0 .8-.358.8-.8 0-.441-.359-.8-.8-.8zm-8.8 8c0 .442-.358.8-.8.8s-.8-.358-.8-.8v-3.201c0-.442.358-.8.8-.8s.8.358.8.8v3.2zm0-9.336c0-.128.168-.264.4-.264h2.4c.232 0 .4.136.4.264v1.336h-3.2zm4.8 9.336c0 .442-.358.8-.8.8s-.8-.358-.8-.8v-3.201c0-.442.358-.8.8-.8s.8.358.8.8v3.2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLegacyTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/legacy-trash.8009246e9a97fd648b4479bfc4392cc8.svg";